module.exports = __webpack_public_path__ + "static/media/ecosystem-mobile.77356bc8.svg";